$(document).ready(function() {
    
    var loginURL = $('.log-in-button').attr('href');
    var modal = $('#terms-modal');

    function isModalOpen() {
        return $('#terms-modal').is(':visible');
    }

    $('.log-in-button').on('click', function(e) {
        e.preventDefault();
        $('#modal_newsletter-terms').prop('checked', false);
        $('#continue-login').addClass('disabled-button');
        modal.fadeIn();
        
        if(isModalOpen){
            $('#modal_newsletter-terms').on('change', function() {
                
              var isCheck = $(this).prop('checked');
                if(isCheck){
                    $('#continue-login').removeClass('disabled-button');
                }else{
                    $('#continue-login').addClass('disabled-button');
                }
            });

            $('#continue-login').on('click', function() {
                modal.fadeOut();
                $('button[data-testid="Checkout-button"]').trigger('click');   
            });

            $(document).on('click', '.close-button-custom', function(e) {
                e.preventDefault();
                modal.fadeOut();
            });
          
            $(document).on('click', '.is-ghost-sample', function() {
                 modal.fadeOut();
            });

             $(document).on('click', '#continue-login', function(){
              var loginURL = $('.log-in-button').attr('href');
              modal.fadeOut();
              window.location.href = loginURL; 
              // alert(loginURL);
            });
        }
    });
});